import React, { Component } from "react";
import { Button, Collapse } from "reactstrap";
import styled from "styled-components";

interface ButtonContainerProps {
    width: number;
}

const ButtonContainer = styled.div<ButtonContainerProps>`
	width: fit-content;
	right: 0px;
	bottom: 0px;
	position: ${(props) => (props.width > 800 ? "absolute" : "relative")};
	display: inline-block;
`;

const RelativeDiv = styled.div`
	position: relative;
	display: inline-block;
	width: 100%;
`;

interface Props {
    isOpen: boolean;
}
class InfoHeader extends Component<Props, { width: number; height: number }> {
    constructor(props: Props) {
        super(props);
        this.state = { width: 0, height: 0 };
        this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    }

    public componentDidMount() {
        this.updateWindowDimensions();
        window.addEventListener("resize", this.updateWindowDimensions);
    }

    public componentWillUnmount() {
        window.removeEventListener("resize", this.updateWindowDimensions);
    }

    public updateWindowDimensions() {
        this.setState({ width: window.innerWidth, height: window.innerHeight });
    }
    public render() {
        return (
            <Collapse
                isOpen={this.props.isOpen}
                id="navbarToggleExternalContent"
                className="bg-dark p-4 pos-f-t"
            >
                <RelativeDiv>
                    <h4 className="text-white" style={{ fontSize: "2.6em" }}>
                        Created with love by{" "}
                        <a href="http://alexanderdavis.net/">Alexander Davis</a>
                    </h4>
                    <span className="text-muted" style={{ fontSize: "1.5em" }}>
                        This website tells you about restaurant closing time discounts.
                    </span>
                    <ButtonContainer width={this.state.width}>
                        <a
                            href="mailto:feedback@alexanderdavis.net"
                            style={{ display: "inline-block" }}
                        >
                            <Button className="btn m-2">Send Feedback</Button>
                        </a>
                        <a
                            href="https://settleup.starlingbank.com/alexanderdavis2"
                            style={{ display: "inline-block" }}
                        >
                            <Button className="btn m-2">Donate</Button>
                        </a>
                    </ButtonContainer>
                </RelativeDiv>
            </Collapse>
        );
    }
}

export default InfoHeader;
